import React from 'react';
import PanelContainer from '@/components/wrappers/PanelContainer';
import fetch from '../../sharing/hooks/fetch';
import DatasourceFeaturesFetch from '../../datasource/containers/DatasourceFeaturesFetch';
import DatasetSettingsFetch from '../containers/DatasetSettingsFetch';

const DatasetAdminPanelContainer = ({
  canRead,
  category,
  children,
  code,
  exists,
  readErrors,
  readStatus,
}) => {
  fetch.useFetchDatasetPermissions({ category, code }, readStatus);
  return (
    <PanelContainer
      canAccess={canRead}
      entity="dataset.admin"
      exists={exists}
      readErrors={readErrors}
      readStatus={[readStatus]}
    >
      <DatasourceFeaturesFetch category={category} code={code} />
      <DatasetSettingsFetch category={category} code={code} />
      {children}
    </PanelContainer>
  );
};

export default DatasetAdminPanelContainer;
